import React from 'react';
import Box from '../Box/Box';
import './MainSection.css';

function MainSection() {
  return (
    <div className='main-div'>
        <div className='main-intro'>
          <div className='intro-text'>
            <span className='intro-span'>Hello, I am</span>
            <h3 className='animate__animated animate__zoomIn animate__slow animate_delay-5s'>Mohamed Hakeem</h3>
            <p>I am a <span>Proffessional Web Developer 💻</span></p>
            <span className='para'>Hi, I am specialized in responsive designs and your website will be designed according to the standards and search engine friendly because I know that a fabulous website is the starting point for your online success.</span>
            <a className='cv' href="./Hakeem's Resume.pdf" title='Click To Download' download='Hakeems resume'>Download CV</a>
            <div className='social-icons'>
              <a href='https://www.facebook.com/' target='_blank'><img src='./images/icons/facebook.png' alt='' /></a>
              <a href='https://instagram.com/thenameis_hakeem' target='_blank'><img src='./images/icons/instagram.png' alt='' /></a>
              <a href='https://wa.me/+94772511686' target='_blank'><img src='./images/icons/whatsapp.png' alt='' /></a>
              <a href='mailto:hakeemfowmi10@gmail.com' target='_blank'><img src='./images/icons/email.png' alt='' /></a>
            </div>
          </div> 
        </div>
        <div className='main-img'>
          <img id='image' src='./images/mainImg.png' alt=''/>
          <div className='floating1'>
            <Box span1='Web' span2='Developer' bgcolor='blue'></Box>
          </div>
          <div className='floating2'>
            <Box span1='Web' span2='Designer' ></Box>
          </div>
          <div className='icon-float bootstrap'>
            <img src='./images/icons/bootstrap.png' alt='' />
          </div>
          <div className='icon-float react'>
            <img src='./images/icons/react.png' alt='' />
          </div>
          <div className='icon-float html'>
            <img src='./images/icons/html.png' alt='' />
          </div>
          <div className='icon-float javascript'>
            <img src='./images/icons/javascript.png' alt='' />
          </div>
          <div className='icon-float css3'>
            <img src='./images/icons/css3.png' alt='' />
          </div>
        </div>
    </div> 
    
  )
}

export default MainSection;